import { PaperClipOutlined } from "@ant-design/icons";
import { Form, Modal, Space, Tag } from "antd";
import notificationApi from "api/notification";
import { roles } from "constants/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUser } from "utils/index";
import style from "../../index.module.scss";
import classNames from "classnames/bind";
import { rolesCanMarkAsRead } from "features/notification/roles";

const cx = classNames.bind(style);
export default function ModalDetail({
  openModal,
  onCancel,
  data,
  lang,
}) {
  const { t } = useTranslation()

  const markAsRead = async () => {
    try {
      await notificationApi.markAsRead(data._id)
    } catch (error) {
    console.log("🚀 ~ error:", error)
    }
  }

  useEffect(() => {
    if (data?._id && rolesCanMarkAsRead.includes(+getUser().role)) {
      markAsRead()
    }
  }, [data])

  return (
    <Modal
      title={t('notification')}
      centered
      open={openModal}
      footer={null}
      onCancel={onCancel}
      width={768}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item
          label={t('sendFrom')}
        >
          <b>{data?.fromUser.name}</b>
        </Form.Item>
        <Form.Item
          label={t('sendTo')}
        >
          {
            getUser().role == roles.shopManager ?
              <b>
                {data?.toUser?.find(user => user.user._id == getUser()._id)?.user.shops?.[0].shop.shop_code}
              </b> :
              data?.toUser.map((user, index) => (
                <Tag key={user._id} color="blue">{user.user.shops[0].shop.shop_code}</Tag>
              ))
          }
          
        </Form.Item>
        <Form.Item
          className={cx('noti-content')}
          label={t('content')}
        >
          <b>{data?.content.find(cont => cont.lang == lang)?.text}</b>
        </Form.Item>
        <Form.Item
          label={t('attachments')}
        >
         <Space direction="vertical">
            {data?.attachments.map((attachment, index) => (
              <Space key={index}>
                <PaperClipOutlined />
                <a href={attachment.fileUrl} target="_blank" rel="noreferrer">{`File ${index + 1}`}</a>
              </Space>
            ))}
         </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}
